import apiClient from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const customerProductAnalyticsService = {
    getAnalytics: async (filters = {}) => {
        try {
            const query = new URLSearchParams(filters).toString();
            // We use the new endpoint mounted under /crm/customers/analytics/product-analytics
            const response = await apiClient.get(`${API_ENDPOINTS.CRM.CUSTOMERS}/analytics/product-analytics?${query}`);
            return {
                success: response.responseCode === 200,
                data: response.data || null,
                error: null
            };
        } catch (error) {
            return {
                success: false,
                data: null,
                error: error.response?.data?.responseMessage || 'Failed to fetch product analytics'
            };
        }
    }
};

export default customerProductAnalyticsService;
